import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from '@app/auth';
import { PrefetchService } from '@app/@shared/services/prefetch.service';

@Injectable({
  providedIn: 'root',
})
export class BankPageService {
  private msg = new BehaviorSubject<boolean>(true);
  currentValue = this.msg.asObservable();

  get isNextBtnDisabled(): boolean {
    return this.msg.value;
  }

  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService,
    public authService: AuthenticationService,
    private prefetchService: PrefetchService,
  ) {}

  /*public headers = new HttpHeaders()
      .set('Content-Type', 'application/json; charset=utf-8')
      .set('Authorization', 'Bearer ' + this.token);*/

  disableNextBtn(value: boolean) {
    this.msg.next(value);
  }

  /*public getZohoRecordId(){
    let decodedToken = Object(this.loginService.decodeToken(this.token));
    //return this.httpClient.get(`/orders/${decodedToken.privilegeId}`, {headers : this.headers})
    return this.httpClient.get(`/orders/${decodedToken.privilegeId}`)
  }*/

  getZohoForm(zohoEncryptedId: string) {
    let decodedToken = Object(this.loginService.decodeToken(this.authService.currentUserValue?.token));
    let privilegeId: number = decodedToken.privilegeId;
    // Route through the shared PrefetchService so a background prefetch (fired from
    // Business Info 2) is reused instead of issuing a new network call.
    return this.prefetchService.getBankForm(zohoEncryptedId, privilegeId);
  }

  /**
   * Prefetch the Zoho banking form URL in the background (no loader) so the Bank
   * page's iframe can start loading immediately when the user reaches it.
   */
  prefetchBankForm(zohoEncryptedId: string) {
    if (!zohoEncryptedId) {
      return;
    }
    let decodedToken = Object(this.loginService.decodeToken(this.authService.currentUserValue?.token));
    let privilegeId: number = decodedToken.privilegeId;
    this.prefetchService.prefetchBankForm(zohoEncryptedId, privilegeId);
  }

  getConfirmationZohoStatus(zohoRecordId: string) {
    //return this.httpClient.get(`/orders/orderInfoZohoStatus/`+ zohoRecordId, {headers : this.headers})
    return this.httpClient.get(`/orders/orderInfoZohoStatus/` + zohoRecordId);
  }

  getRamJsonFromDB(queryParams = {}) {
    let decodedToken = Object(this.loginService.decodeToken(this.authService.currentUserValue?.token));
    //return this.httpClient.get(`/orders/${decodedToken.privilegeId}/ram`, {headers : this.headers})
    return this.httpClient.get(`/orders/${decodedToken.privilegeId}/ram`, { params: queryParams });
  }

   getRamJsonByOrderInfoId(orderInfoId: number, queryParams = {}) {
    console.log("fetching ram json for orderInfoId:", orderInfoId);
    return this.httpClient.get(`/orders/` + orderInfoId, { params: queryParams });
  }
}
